import { useBackendApi } from './backendApi';
import { EmailProvider, EmailConnection } from './Types';
import { OAuthUrlResponse } from "./oAuthIdentityService";


export interface CreateConnectionRequest {
  code: string;
}

export const EMAIL_CONNECTIONS_UPDATED = 'EMAIL_CONNECTIONS_UPDATED';

export function useEmailConnectionsService() {
  const nekstApi = useBackendApi();

  const getOAuthUrl = async (provider: EmailProvider): Promise<OAuthUrlResponse> => {
    return await nekstApi.get(`/emailconnection/oauth/${provider}/link`) as OAuthUrlResponse;
  };

  const createConnection = async (provider: EmailProvider, request: CreateConnectionRequest): Promise<EmailConnection> => {
    return await nekstApi.post(`/emailconnection/oauth/${provider}`, request) as EmailConnection;
  };

  const deleteConnection = async (): Promise<void> => {
    await nekstApi.delete('/emailconnection');
  };

  const getConnection = async (): Promise<EmailConnection | null> => {
    return await nekstApi.get('/emailconnection') as EmailConnection | null;
  };

  return {
    getOAuthUrl,
    createConnection,
    deleteConnection,
    getConnection,
  };
}
